<template>
    <div class="page">
        <toolbar-system></toolbar-system>
        <progress-system :isLoad="system.progress"></progress-system>
        <alertbar-system v-if="system.AlertbarShow != null" :alertbar="system.AlertbarShow"></alertbar-system>
        <v-container class="animated fadeIn" v-show="novoParceiroView">
            <v-layout align-center justify-center wrap>
                <v-flex xl12>
                    <v-card>
                        <v-card-title>
                            <h1 class="display-1 text-uppercase">Gestão de parceiros</h1>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-form>
                                <!-- <v-text-field v-model="parceiro.nome" color="blue" label="Nome parceiro"></v-text-field> -->
                                <v-autocomplete 
                                    v-if="btnParceiroEditar == true"
                                    v-model="IdpessoaJuridica"
                                    :items="pessoaJuridicaList"
                                    item-text="RazaoSocial"
                                    item-value="IdPessoaJuridica"
                                    label="Nome do parceiro"
                                    :rules="[rules.required]"
                                    readonly
                                    dense
                                    filled
                                >
                                </v-autocomplete>
                                <v-autocomplete 
                                    v-else
                                    v-model="IdpessoaJuridica"
                                    :items="pessoaJuridicaList"
                                    item-text="RazaoSocial"
                                    item-value="IdPessoaJuridica"
                                    label="Nome do parceiro"
                                    :rules="[rules.required]"
                                >
                                </v-autocomplete>

                                <v-text-field 
                                    v-model="atoDeMesa" 
                                    color="blue" 
                                    label="Ato de mesa"
                                    :rules="[rules.required]"
                                ></v-text-field>

                                <v-menu
                                    ref="menuDataVigenciaInicial"
                                    v-model="menuDataVigenciaInicial"
                                    :close-on-content-click="false"
                                    :return-value.sync="dataVigenciaInicial"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        color="info" 
                                        v-model="dataVigenciaInicial"
                                        label="Data da vigencia inicial"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker
                                    v-model="dataVigenciaInicial"
                                    no-title
                                    scrollable
                                    >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="info"
                                        @click="menuDataVigenciaInicial = false"
                                    >
                                        Cancel
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="info"
                                        
                                        @click="$refs.menuDataVigenciaInicial.save(dataVigenciaInicial)"
                                    >
                                        OK
                                    </v-btn>
                                    </v-date-picker>
                                </v-menu>

                                <v-menu
                                    ref="menuDataVigenciaFinal"
                                    v-model="menuDataVigenciaFinal"
                                    :close-on-content-click="false"
                                    :return-value.sync="dataVigenciaFinal"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="dataVigenciaFinal"
                                        label="Data da vigencia final"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        color="info"
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker
                                    v-model="dataVigenciaFinal"
                                    no-title
                                    scrollable
                                    >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="info"
                                        @click="menuDataVigenciaFinal = false"
                                    >
                                        Cancel
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="info"
                                        
                                        @click="$refs.menuDataVigenciaFinal.save(dataVigenciaFinal)"
                                    >
                                        OK
                                    </v-btn>
                                    </v-date-picker>
                                </v-menu>
                                <input accept="images/*" ref="image" type="file" @change="changeFile($event)" style="display: none">
                                <v-text-field :rules="[rules.required]" v-model="nameFile" color="blue" @click="loadFile()" label="Arquivo" prepend-icon='mdi mdi-paperclip'></v-text-field>
                                <v-textarea :rules="[rules.required]" counter no-resize rows="5" label="Descrição" v-model="textoDescricao" color="info"></v-textarea>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn @click="[novoParceiroView = false, btnParceiroEditar = false, nullFields()]" class="silver" large dark>
                                Cancelar
                            </v-btn>
                            <v-btn v-if="btnParceiroEditar == false" @click="cadastrarParceiro()" class="blue" large dark>
                                Enviar
                            </v-btn>
                            <v-btn v-else @click="atualizarParceiro()" class="blue" large dark>
                                Atualizar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-container>
            <v-layout>
                <v-flex xl12>
                    <v-card flat>
                        <v-card-title>
                            <v-text-field
                                v-model="search"
                                color="blue"
                                label="Parceiros"
                                prepend-icon="mdi mdi-database-search"
                            ></v-text-field>
                            <v-btn
                                dark
                                color="blue"
                                @click="[novoParceiroView = !novoParceiroView, nullFields(), btnParceiroEditar= false]"
                            >
                                <v-icon left>mdi mdi-plus</v-icon>Novo parceiro
                            </v-btn>
                        </v-card-title>
                        <v-data-table
                        :headers="headersParceiros"
                        :items="parceiroslist"
                        :search="search">
                            <template v-slot:items="props">

                                <v-chip
                                    class="text-xs-right ma-7"
                                    v-if="props.item.VigenciaFinal < todayDate"
                                    color="red"
                                    outlined
                                    >
                                    Expirado
                                    </v-chip>
                                    <v-chip cols="6"
                                    class="text-xs-right ma-7"
                                    v-else-if="props.item.VigenciaInicial > todayDate"
                                    color="gray"
                                    outlined
                                    >
                                    A iniciar
                                    </v-chip>
                                    <v-chip
                                    class="text-xs-right ma-7"
                                    v-else
                                    color="success"
                                    outlined
                                    >
                                    Vigente
                                    </v-chip>
                                <td class="text-xs-left">{{ props.item.RazaoSocial }}</td>
                                <td class="text-xs-center">{{ props.item.AtoDeMesa }}</td>
                                <td class="text-xs-center">{{ format_CNPJ(props.item.CNPJ) }}</td>
                                <td class="text-xs-center">{{ format_date(props.item.VigenciaInicial) }}</td>
                                <td class="text-xs-center">{{ format_date(props.item.VigenciaFinal) }}</td>

                                    <v-tooltip>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                icon
                                                @click="[editarParceiro(props.item)]"
                                            >
                                                <v-icon color="info">mdi-pencil</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Editar</span>
                                    </v-tooltip>
                                    <v-tooltip>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                icon
                                                @click="[deleteParceiro(props.item.IdParceiro)]"
                                            >
                                                <v-icon color="red">mdi-delete</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Excluir</span>
                                    </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
import ToolbarSystem from '../../../components/ToolbarSystem'
import AlertbarSystem from '../../../components/AlertbarSystem'
import ProgressSystem from '../../../components/ProgressSystem'
import moment from 'moment'
export default {
    components:{
        ToolbarSystem,
        AlertbarSystem,
        ProgressSystem
    },
    data () {
        return{
            system:{
                sideIcon: true,
                progress: true,
                AlertbarShow: null
            },
            headersParceiros:[
                {text:'Status', value:'chips', width:"10%", align:"center"},
                {text:'Nome', value:'RazaoSocial', width:"20%", align:"left"},
                {text:'Ato de mesa', value:'AtoDeMesa', width:"20%", align:"center"},
                {text:'CNPJ', value:'CNPJ', width:"20%", align:"center"},
                {text:'Data de inicio de vigência', value:'VigenciaInicial', width:"10%", align:"center"},
                {text:'Data de fim da vigência', value:'VigenciaFinal', width:"10%", align:"center"},
                {text:'Actions', value:'actions', width:"10%", align:"center"},
            ],
            rules: {
                required: v => !!v || 'Campo obrigatório',
            },
            pessoaJuridicaList: [],
            parceiroslist: [],
            search: null,
            textoDescricao: null,
            IdpessoaJuridica: null,
            dataVigenciaInicial: null,
            dataVigenciaFinal: null, 
            IdParceiro: null,
            AnexoFile: null,
            menuDataVigenciaInicial: false,
            menuDataVigenciaFinal: false,
            todayDate: null,
            atoDeMesa: "",
            file: null,
            nameFile: null,
            novoParceiroView: null,
            btnParceiroEditar: false,
        }
    },
    methods: {
        nullFields(){
            this.IdpessoaJuridica = null,
            this.atoDeMesa = null,
            this.dataVigenciaInicial = "",
            this.dataVigenciaFinal = "",
            this.file = null,
            this.textoDescricao = null
            this.IdParceiro = null
            this.AnexoFile = null
            this.nameFile = null
        },
        get_date_today(){
            const today = new Date();
            const year = today.getFullYear();
            const month = today.getMonth() + 1; // Months are zero-based
            const day = today.getDate();

            // Format the date as a string (e.g., "YYYY-MM-DD")
            const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
            this.todayDate = formattedDate;
        },
        format_date(value){
            if (value) {
                return moment(String(value)).format('DD/MM/YYYY');
            }
        },
        format_CNPJ(cnpj) {
            cnpj = cnpj.replace(/\D/g, '');
            return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
        },
        loadFile(){
            this.$refs.image.click ()
        },
        changeFile(e){
            this.file = e.target.files
            this.nameFile = this.file[0].name
        },
        cadastrarParceiro(){
            this.system.progress = true

            let formData = new FormData()
            formData.append('IdPessoaJuridica', this.IdpessoaJuridica),
            formData.append('Texto', this.textoDescricao),
            formData.append('AtoDeMesa', this.atoDeMesa),
            formData.append('VigenciaInicial', this.dataVigenciaInicial),
            formData.append('VigenciaFinal', this.dataVigenciaFinal),
            formData.append('Anexo', this.file == null ? "" : this.file[0]),
            formData.append('_method', "POST"),

            this.axios.post(`parceiro/`, formData, {
                headers: {'Content-Type': 'multipart/form-data'}
            }).catch(e => {
                this.system.progress = false
                this.system.AlertbarShow = {
                    show: true,
                    time: 10000,
                    text: e.response.data,
                    bottom: false,
                    right: true,
                    multi: true,
                    color: "error"
                }
            }).then(res => {
                this.system.progress = false
                this.system.AlertbarShow = {
                    show: true,
                    time: 10000,
                    text: res.data,
                    bottom: false,
                    right: true,
                    multi: true,
                    color: "success",
                }
                this.getParceiros()
                this.nullFields()
            })
            .finally(() => {
                this.novoParceiroView = false
            })
        },
        getPessoaJuridica(){
            this.axios.get('pessoaJuridica/').then(res => {
                this.pessoaJuridicaList = res.data
            }).finally(() => {
                this.system.progress = false
            })
        },
        getParceiros(){
            this.system.progress = true
            this.axios.get(`parceiro/`).then(res => {
                this.parceiroslist = res.data;
            }).catch(e => {
                this.system.progress = false
                this.system.AlertbarShow = {
                    show: true,
                    time: 10000,
                    text: e.response.data,
                    bottom: false,
                    right: true,
                    multi: true
                }
            }).finally(() => {
                this.system.progress = false
            })

        },
        deleteParceiro(id){
            let com = confirm('Deseja realmente excluir esse parceiro?')
            if(com){
                this.system.progress = true
                this.axios.delete(`parceiro/${id}`)
                .then(res => {

                    this.system.AlertbarShow = {
                        show: true,
                        time: 10000,
                        text: res.data,
                        bottom: false,
                        right: true,
                        multi: true,
                        color:"success"
                    }
                    this.getParceiros()
                }).catch(e => {
                this.system.progress = false
                this.system.AlertbarShow = {
                    show: true,
                    time: 10000,
                    text: e.response.data,
                    bottom: false,
                    right: true,
                    multi: true,
                    color:"alert"}
                }).finally(() => {
                    this.nullFields()
                })
            }
        },
        atualizarParceiro(){
            this.system.progress = true

            let formData = new FormData()
            formData.append('IdPessoaJuridica', this.IdpessoaJuridica),
            formData.append('Texto', this.textoDescricao),
            formData.append('AtoDeMesa', this.atoDeMesa),
            formData.append('VigenciaInicial', this.dataVigenciaInicial),
            formData.append('VigenciaFinal', this.dataVigenciaFinal),
            formData.append('Anexo', this.file == null ? "" : this.file[0]),
            // formData.append('_method', "PUT"),

            this.axios.post(`parceiro/${this.IdParceiro}?_method=PUT`, formData, {
                headers: {'Content-Type': 'multipart/form-data'}
            }).then(res => {
                this.novoParceiroView = false
                this.btnParceiroEditar = true
                this.system.AlertbarShow = {
                    show: true,
                    time: 10000,
                    text: res.data,
                    bottom: false,
                    right: true,
                    multi: true,
                    color: "success"
                }
                this.getParceiros()
            }).finally(() => {
                this.nullFields()
            })
        },
        editarParceiro(item){
            this.novoParceiroView = true
            this.btnParceiroEditar = true
            this.IdParceiro = item.IdParceiro
            this.IdpessoaJuridica = item.IdPessoaJuridica
            this.atoDeMesa = item.AtoDeMesa
            this.dataVigenciaInicial = moment(String(item.VigenciaInicial)).format('YYYY-MM-DD')
            this.dataVigenciaFinal = moment(String(item.VigenciaFinal)).format('YYYY-MM-DD')
            this.textoDescricao= item.Texto
            this.nameFile = item.Anexo
        }
    },
    mounted(){
        this.getParceiros();
        this.getPessoaJuridica();
        this.get_date_today()
    }
}
</script>
<style>

</style>

